<script>
  // import each calculator component - four calculators and select
  import AffordabilityCalculator from './affordabilityCalculator/AffordabilityCalculator.svelte';
  import CalculatorSelect from './CalculatorSelect.svelte';
  import IncomeRequiredCalculator from './incomeRequiredCalculator/IncomeRequiredCalculator.svelte';
  import MortgagePaymentCalculator from './mortgagePaymentCalculator/MortgagePaymentCalculator.svelte';
  import RefinanceSavingsCalculator from './refinanceSavingsCalculator/RefinanceSavingsCalculator.svelte';
  import ReverseMortgageCalculator from './reverseMortgageCalculator/ReverseMortgageCalculator.svelte';

  // from localized PHP data via calculators.js
  export let company;
  export let grayIcons;

  // Mortgage Payment calculator is visible on page load
  let activeCalculator = MortgagePaymentCalculator;

  // reference to calculator components so string can be passed in to change active calculator
  let calculators = {
    AffordabilityCalculator,
    IncomeRequiredCalculator,
    MortgagePaymentCalculator,
    RefinanceSavingsCalculator,
    RefinanceSavingsCalculator,
    ReverseMortgageCalculator,
  };

  let activeCalculatorString = "MortgagePaymentCalculator";

  /**
   *
   * @param {string} calculator - name of the calculator to be made active, corresponding with calculators property
   * @param {Object} e - the keyboard event (mouse event is not passed in)
   * @return {undefined} exit the function if not Enter key
   *
   * Set active calculator - clicks are handled in CalculatorSelect component, keys are handled here
   */
  function setActiveCalculator(calculator, e = null) {
    if (e) {
      // it is surprisingly hard to find a good 'how to detect if enter key' answer on the internet
      if (e.key === 'Enter' || e.keyCode === 13) {
        activeCalculator = calculators[calculator];
      }
      return;
    }

    activeCalculator = calculators[calculator];
    activeCalculatorString = calculator;
  }
</script>

<section aria-label="Mortgage Calculators" class="flex justify-center">
  <div class="container no-padding-xs mb-20">
    <CalculatorSelect {grayIcons} {activeCalculatorString} {setActiveCalculator} />
    <div class="sm:border sm:border-gray-beethree">
      <svelte:component this={activeCalculator} {company} />
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/CalculatorContainer.svelte